export const FORM_ID = 'searchForm';
